import React from "react";
import PropTypes from "prop-types";
import ErrorIcon from "@mui/icons-material/Error";
import ArrowIcon from "@mui/icons-material/KeyboardArrowRight";
import { CheckIcon } from "@akj-dev/shared-components";

interface ConfigStatusProps {
  isValid: boolean;
  onClick?: () => void;
}

export const ConfigStatus = ({ isValid, onClick }: ConfigStatusProps) => {
  return (
    <div className="ConfigurationStatus">
      {isValid ? (
        <CheckIcon />
      ) : (
        <div className="false" onClick={onClick}>
          <ErrorIcon color="error" />
          <ArrowIcon color="error" />
        </div>
      )}
    </div>
  );
};

ConfigStatus.propTypes = {
  isValid: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
